"use strict";
exports.__esModule = true;
exports.global_Color_light_300 = {
  "name": "--pf-v5-global--Color--light-300",
  "value": "#d2d2d2",
  "var": "var(--pf-v5-global--Color--light-300)"
};
exports["default"] = exports.global_Color_light_300;